import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

import { computed } from "vue";
  import LoadingSpinner from "./components/LoadingSpinner.vue";
  import LtkError from "./views/LtkError.vue";
  import { useAppStore } from "./stores/app";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const appStore = useAppStore();
  const hasError = computed(() => appStore.hasError);
  const isLoading = computed(() => appStore.isLoading);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (hasError.value)
            ? (_openBlock(), _createBlock(LtkError, { key: 0 }))
            : (isLoading.value)
              ? (_openBlock(), _createBlock(LoadingSpinner, {
                  key: 1,
                  size: "40",
                  color: "grey darken-3"
                }))
              : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_router_view, null, null, 512), [
            [_vShow, !isLoading.value && !hasError.value]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})